import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Matter } from '@/types';

// Assuming matterId is a string and fetchConfigGET is your fetch configuration for GET requests
export const useGetMatter = (id: string) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const navigate = useNavigate();

  const getMatterData = async () => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${id}`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching matter data failed');
    }
    // Check if the user is not authorised to view this matter
    if (response.status === 403) {
      toast.error('Unauthorized. You are being redirected to the matters explorer.');
      navigate(`/app/chronos/matters`);
    }

    return await response.json();
  };

  return useQuery<Matter, Error>(['matterDataResult', id], getMatterData, {
    enabled: !!id, // Only run the query if the matterId is provided
    refetchOnWindowFocus: false,
  });
};
